document.querySelectorAll("img.image-popup").forEach(img => {
	let anchor = document.createElement("a");
	img.parentElement.appendChild(anchor);
	anchor.appendChild(img);
	anchor.href = img.src;
	anchor.addEventListener("click", clickAnchor);

	let cloneImg = img.cloneNode();
	cloneImg.classList.add("pop-out");
	anchor.appendChild(cloneImg);

	function clickAnchor(e) {
		e.preventDefault();
		this.classList.toggle("pop-out-enabled");
	}
});

(function() {
	document.addEventListener("keyup", e => {
		if(e.code === "Escape") {
			document.querySelectorAll(".pop-out-enabled").forEach(a => {
				a.classList.remove("pop-out-enabled");
			})
		}
	})
})();
